module.exports = __webpack_public_path__ + "static/media/3-SanchezRamos.66830736.png";